import * as urlParsers from "./urlParsers";
import wrappedAxios from "../axiosWrapper";
import { LangCode } from "./types";

export const changeLanguage = (langCode: LangCode) =>
  wrappedAxios<Record<string, unknown>>({
    url: urlParsers.changeLanguage(langCode),
    method: "post",
  });

export const getLanguage = () =>
  wrappedAxios<LangCode>({
    url: urlParsers.getLanguage(),
    method: "get",
  });
